import React, { useEffect, useState } from 'react';
import { Button, Divider, Space, Tag, TreeSelect } from 'antd';
import { DB_DATA_FIELDS } from "./dbConstants";

const columsName = Object.keys(DB_DATA_FIELDS);
const treeData = columsName.map((data) => DB_DATA_FIELDS[data]);

const DataFilter = ({disabled=false,
  queryFieldsChange,
}) => {
  const [fields, setFields] = useState(['ai_system_voltage', 'soc', 'temperature_max']);
  const helperMsg = 'Can Select upto 3 fields';
  const [filterVisible, setFilterVisible] = useState(false);

  const handleChange = (value, label, extra) => { 
    setFields(value);
  };
  
  const onFilter = () => {
    let panelList = {IMU:[], TELEMETRY:[], MOTOR:[], BATTERY:[], LOCATION:[]};
    fields.forEach(field => {
      let parentKey = null;
      for (const parent of treeData) {
        for (const child of parent.children) {
           if (child.value === field){
            parentKey = parent.value.toUpperCase();
            panelList[parentKey].push(child);
            break;
           }
        }
        if (parentKey) break;
      }
    });
    queryFieldsChange(panelList);
    setFilterVisible(false);
  }

  useEffect(() => {
    onFilter();
  }, [])

  return (   
      <TreeSelect
        treeData={treeData}
        value={fields}
        onChange={handleChange}
        style={{ maxWidth: 360 }}
        tagRender={(tag) => 
          (<Tag style={{marginRight: 3}} closable={false}>{tag?.label}</Tag>)
        }
        maxCount={3}
        treeCheckable
        className='w100'
        open={filterVisible}
        disabled={disabled}
        placeholder="Please select"
        maxTagCount={'responsive'}
        treeDefaultExpandAll={true}
        showCheckedStrategy={TreeSelect.SHOW_CHILD}
        onDropdownVisibleChange={(e) => setFilterVisible(e)}
        dropdownRender={(menu) => (
          <>
            {menu}
            <Divider style={{ margin: '8px 0' }} />
            <div className='flex-center' style={{ padding: '0 8px 4px' }}>
              <span style={{marginRight: '10px'}}>{helperMsg}</span>
              <Button onClick={onFilter}> Apply </Button>
            </div>
          </>
        )}
      />
  );
};
export default DataFilter;